import { NodeViewContent, NodeViewWrapper, type NodeViewProps } from '@tiptap/react'
import { recogniseEmbed } from '@staleless/markdown'

/**
 * A video or interactive demo.
 *
 * The editor does NOT frame the content. A live iframe inside a document someone
 * is typing into steals focus, plays audio, and reloads on every keystroke that
 * re-renders the node. It shows what the URL was recognised as instead, which is
 * the information the writer actually needs: whether it will render.
 */
export function EmbedView({ node, updateAttributes, editor }: NodeViewProps) {
  const url = (node.attrs['url'] as string | null) ?? ''
  const recognised = url ? recogniseEmbed(url) : null

  return (
    <NodeViewWrapper className="be-embed" data-sls="embed">
      <div className="be-embed__head" contentEditable={false}>
        <span className={`be-embed__badge${recognised ? ' is-known' : ''}`}>
          {recognised ? recognised.provider : url ? 'not embeddable' : 'empty'}
        </span>
        <input
          className="be-inline-input"
          value={url}
          placeholder="https://youtu.be/..."
          disabled={!editor.isEditable}
          onChange={(e) => updateAttributes({ url: e.target.value || null })}
        />
      </div>
      {url && !recognised && (
        <p className="be-embed__warn" contentEditable={false}>
          This will render as a link. YouTube, Loom, Vimeo and Arcade are framed; anything else is
          not, because an arbitrary page in a frame can run its own code beside your readers.
        </p>
      )}
      <NodeViewContent className="be-embed__caption" />
    </NodeViewWrapper>
  )
}
